import React from "react";
import MarkerCombobox from "@/components/MarkerCombobox";

export const BiomarkerForm = ({
  marker, onMarkerSelect, value, setValue, unit, setUnit,
  date, setDate, notes, setNotes, submit,
}) => (
  <form onSubmit={submit} className="bg-[#F1ECE4] border border-[#D1C7B8] rounded-3xl p-6 space-y-4" data-testid="biomarker-form">
    <p className="label-eyebrow">Record a marker</p>
    <div>
      <label className="text-xs text-[#5C6359] block mb-1">Marker</label>
      <MarkerCombobox value={marker} onChange={onMarkerSelect} />
    </div>
    <div className="grid grid-cols-2 gap-3">
      <div>
        <label className="text-xs text-[#5C6359] block mb-1">Value</label>
        <input type="number" step="0.01" required value={value} onChange={(e) => setValue(e.target.value)} data-testid="marker-value" className="w-full bg-transparent border-b border-[#D1C7B8] focus:border-[#C05C42] py-2 outline-none text-[#2D322B]" />
      </div>
      <div>
        <label className="text-xs text-[#5C6359] block mb-1">Unit</label>
        <input value={unit} onChange={(e) => setUnit(e.target.value)} data-testid="marker-unit" className="w-full bg-transparent border-b border-[#D1C7B8] focus:border-[#C05C42] py-2 outline-none text-[#2D322B]" />
      </div>
    </div>
    <div>
      <label className="text-xs text-[#5C6359] block mb-1">Date</label>
      <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="marker-date" className="w-full bg-transparent border-b border-[#D1C7B8] focus:border-[#C05C42] py-2 outline-none text-[#2D322B]" />
    </div>
    <div>
      <label className="text-xs text-[#5C6359] block mb-1">Notes</label>
      <input value={notes} onChange={(e) => setNotes(e.target.value)} data-testid="marker-notes" className="w-full bg-transparent border-b border-[#D1C7B8] focus:border-[#C05C42] py-2 outline-none text-[#2D322B]" />
    </div>
    <button type="submit" className="btn-primary w-full" data-testid="add-marker-btn">Add entry</button>
  </form>
);
